import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { RequestSubForm } from '../request-sub-form.component';

@Component({
    selector: 'live-load-request-form',
    templateUrl: './live-load-request-form.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LiveLoadhRequestFormComponent extends RequestSubForm {
  pageName = 'RequestLiveLoad';
}
